export default "__VITE_ASSET__fZJuo75b__"